import React, { ReactElement } from "react";

interface IconLinkProps {
  href: string;
  label: string;
  iconAlt: string;
  iconSrc: string;
  style?: Record<string, unknown>;
}

export default class IconLink extends React.Component<IconLinkProps> {
  render(): ReactElement {
    return (
      <a className="icon-link" href={this.props.href} style={this.props.style}>
        <div className="name">
          <img alt={this.props.iconAlt} src={this.props.iconSrc} />
          <div className="text">{this.props.label}</div>
        </div>
      </a>
    );
  }
}
